// Point de branchement UNIQUE latin / 9 autres ecritures, reutilise par tous
// les endroits du site qui affichent une punchline a partir d'un
// enregistrement Generation (Dashboard, Carte, Sillage, exports...).
//
// Latin ("Latn", ou script absent -- anciens enregistrements) : rendu en
// direct, comme aujourd'hui (gen_svg.js / lineEngine.js), instantane.
// Les 9 autres ecritures : deja calcule UNE FOIS a la creation (page
// "Proposer", bouton "Generer l'apercu", /api/knockout) et stocke en base
// (knockoutSvg, knockoutLineData) -- on reutilise ce resultat tel quel,
// jamais de recalcul ici (le pipeline serveur prend 15-90s, impossible a
// refaire a chaque affichage).

/**
 * SVG statique pour une punchline stockee.
 * @returns {Promise<string>}
 */
export async function resolveStaticSvg({ script, text, knockoutSvg, generateSVG, fontBuffer, color }) {
  if (script && script !== 'Latn' && knockoutSvg) return knockoutSvg;
  return generateSVG(text, fontBuffer, color);
}

/**
 * Donnees d'animation ({ p2ds, rects, pw, canvasH, rectTopY, rectH }) pour une
 * punchline stockee -- meme forme que prepareAnimLine(), consommable
 * directement par drawLine()/drawLineInCtx() (lineEngine.js).
 * @returns {Promise<object|null>}
 */
export async function resolveLineData({ script, text, knockoutLineData, prepareAnimLine, font }) {
  if (script && script !== 'Latn' && knockoutLineData) {
    const { pathData, pathParts, ...rest } = knockoutLineData;
    // pathParts (un contour par lettre) prioritaire sur pathData (chaine
    // unique, ancien format) -- retombe sur [pathData] pour les punchlines
    // deja stockees en base avant ce correctif (25 septembre 2026), qui
    // n'ont que pathData. Voir le commentaire sur p2ds dans lineEngine.js
    // pour pourquoi UN Path2D par lettre est necessaire (pas juste un p2d
    // combinant tout le mot/groupe).
    const parts = pathParts ?? [pathData];
    return { p2ds: parts.map((d) => new Path2D(d)), ...rest };
  }
  return prepareAnimLine(text, font);
}

/** true si l'ecriture necessite le pipeline serveur (pas de rendu instantane). */
export function isServerScript(script) {
  return Boolean(script) && script !== 'Latn';
}
